import { ErrorMessage, useFormikContext } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';

import styles from './FormErrorMessage.module.scss';

const FormErrorMessage = React.memo(({ name }) => {
  const { errors, touched } = useFormikContext();

  return errors[name] && touched[name] ? (
    <ErrorMessage className={styles.errorMessage} name={name} component="div" />
  ) : null;
});

FormErrorMessage.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormErrorMessage;
